import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import NoteComponent from './NoteComponent';

import { lengthValidation250, required } from '../Forms/utils';

import { STYLED_TEXT } from '../Forms/fieldTypes';

const OpenVendorComponent = ({
  openVendorNote,
  form,
  onSubmit,
  onModalClose,
  accessPoint,
}) => {
  const { t } = useTransl();
  const formData = [
    {
      keyName: 'note',
      label: t('title.comment'),
      fieldType: STYLED_TEXT,
      multiline: true,
      validate: [required, lengthValidation250],
    },
  ];

  return (
    <>
      <NoteComponent note={openVendorNote} />
      <GenericFormContainer
        form={form}
        formData={formData}
        onSubmit={onSubmit}
        onModalClose={onModalClose}
        accessPoint={accessPoint}
        title={t('callCenter.openVendor')}
        isUpdate={false}
        canBeUpdated={false}
        submitText={t('callCenter.openVendor')}
        backButton={false}
        isFullWidthForm
        isFullWidthSubmit
        customSubmitStyle={{
          marginTop: '0.5rem',
        }}
      />
    </>
  );
};

OpenVendorComponent.defaultProps = {
  onSubmit: () => {},
  onModalClose: () => {},
  openVendorNote: null,
  accessPoint: {},
};

OpenVendorComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  openVendorNote: PropTypes.string,
  onModalClose: PropTypes.func,
  accessPoint: PropTypes.instanceOf(Object),
};

export default OpenVendorComponent;
